import { compose, withHandlers, defaultProps } from 'recompose';

import connect from 'app/libs/connect';
import Button from 'app/components/Button/Button';
import { viewPlansCtaSelected } from 'app/features/landing/viewPlansCta/actions';
import { PRODUCT_COMPARISON_ANCHOR } from 'app/features/landing/productComparison/constants';

const onClick =
  ({ viewPlansCtaSelected, position, textKey }) =>
  () => {
    document.getElementById(PRODUCT_COMPARISON_ANCHOR).scrollIntoView({
      behavior: 'smooth',
    });

    viewPlansCtaSelected({ position, textKey });
  };

const actions = { viewPlansCtaSelected };

const ViewPlansCta = compose(
  defaultProps({ type: 'one', isWideOnMobile: true }),
  connect(null, actions),
  withHandlers({ onClick }),
)(Button);

export { onClick };

export default ViewPlansCta;
